export default __webpack_public_path__ + "static/logo-f818b59c5621da34019df9c68ffc3dc4.svg";